export default "__VITE_ASSET__4a324252__"